import React, { useEffect, useState } from 'react'
import { EditCartItemProps, LumpsumValidationType, SipValidationType, StpValidationType, SwpValidationType } from '../types'
import Sip from './Sip'
import Lumpsum from './Lumpsum'
import { useDispatch, useSelector } from 'react-redux'
import { getInvestmentDetails, getStpWeekDays } from '../../../redux-store/actions/funds'
import { GETINVESTMENTDETAILTYPE, InvestmentFundType } from '../../../redux-store/types/api-types'
import Swp from './Swp'
import Stp from './Stp'
import Switch from './Switch'
import Reedem from './Reedem'
import { RootStateType } from '../../../redux-store/reducers'
import { MpowerValidationType } from '../../investorOverview/types'
import { getMandateCreationDetails } from '../../../redux-store/actions/investorProfile'
import { MandateCreation } from '../../../redux-store/types/investorProfile'
import { StpWeekDaysObj } from '../../../redux-store/types/funds'

type Props = {
    currentTransactionType: string,
    data: EditCartItemProps;
    handleSetState: (object: any) => void
}

const Index = ({ currentTransactionType, data, handleSetState }: Props) => {
    const { activeCategory } = data
    const dispatch = useDispatch()
    const { selectedPortfolio } = useSelector((state: RootStateType) => state.selectedPortfiolio)
    const { investorClientId, iwappRmId = "" } = useSelector((state: RootStateType) => state.id)

    //state
    const [folio, setFolio] = useState<string[]>([])
    const [schemeLoading, setSchemeLoading] = useState(false)
    const [bankDetails, setBankDetails] = useState<Array<MandateCreation>>([] as Array<MandateCreation>);
    const [weeklyDaysValidation, setWeeklyDaysValidation] = useState<Array<StpWeekDaysObj>>([])


    const [lumpsumValidation, setLumpsumValidataion] = useState<MpowerValidationType>({} as MpowerValidationType)
    const [sipValidation, setSipValidation] = useState<SipValidationType>({} as SipValidationType)
    const [swpValidation, setSwpValidation] = useState<SwpValidationType>({} as SwpValidationType)
    const [stpValidation, setStpValidation] = useState<StpValidationType>({} as StpValidationType)

    const [sipMpowerValidation, setSipMpowerValidation] = useState<MpowerValidationType>({} as MpowerValidationType)
    const [redeemScheme, setRedeemScheme] = useState({} as InvestmentFundType)
    const [switchScheme, setSwitchScheme] = useState({} as InvestmentFundType)
    const [stpScheme, setStpScheme] = useState({} as InvestmentFundType)
    const [SwpScheme, setSwpScheme] = useState({} as InvestmentFundType)
    const [sipScheme, setsipScheme] = useState({} as InvestmentFundType)
    const [lumpsumScheme, setlumpsumScheme] = useState({} as InvestmentFundType)



    useEffect(() => {
        const fetch = async () => {
            try {
                setSchemeLoading(true)
                const res = await dispatch(getInvestmentDetails({
                    schemeIds: [data.toSchemeId || data.fromSchemeId],
                    portfolioId: selectedPortfolio?.value,
                    schemeDetails: [{
                        scheme_id: (data?.transactionType?.toLowerCase() === 'switch' || data?.transactionType?.toLowerCase() === 'stp') ? data?.toSchemeId : data?.schemeId ?? "",
                        isReinvestment: data?.isDividendReinvestment ?? ""
                    }],
                    clientCode: investorClientId,
                    rmId: `${iwappRmId}`,
                }) as unknown) as GETINVESTMENTDETAILTYPE;
                if(!res) return;
                 handleSetState(res.investmentDetails[0]);
                if (currentTransactionType === 'redemption' || currentTransactionType === 'swp') {
                    const bankDetailsRes = (await dispatch(getMandateCreationDetails({ clientCode: investorClientId, portfolioId: selectedPortfolio?.value }))) as unknown as any
                    setBankDetails(bankDetailsRes);
                }

                if (["fresh", "additional"].includes(`${currentTransactionType ?? ""}`.toLowerCase())) {
                    //lumpsum
                    setLumpsumValidataion(res?.investmentDetails[0].validations.filter((item: MpowerValidationType) => item?.transactionType ===
                        "SUB")[0])
                    setlumpsumScheme(res?.investmentDetails?.[0])
                }

                if (currentTransactionType === 'sip') {
                    setsipScheme(res?.investmentDetails?.[0])
                    //sip
                    setSipValidation(res?.investmentDetails[0]?.validataion?.sip as any)
                    // setSipMpowerValidation(res?.investmentDetails[0].validations.filter((item: MpowerValidationType) => item?.transactionType ===
                    //     "SIP")[0])
                }
                //need some api change in swp, reedem, stp

                if (currentTransactionType === "swp") {
                    setSwpValidation(res?.investmentDetails[0]?.validataion?.sip as any)
                    setSwpScheme(res?.investmentDetails?.[0])
                }

                if (currentTransactionType === "stp") {
                    setStpValidation(res?.investmentDetails[0]?.validataion?.sip as any)
                    setStpScheme(res?.investmentDetails?.[0])

                    const response = await (dispatch(getStpWeekDays()) as unknown as Promise<Array<StpWeekDaysObj>>)
                    setWeeklyDaysValidation(response ?? [])
                }

                if (currentTransactionType === "switch") {
                    setSwitchScheme(res?.investmentDetails?.[0])
                }

                if (currentTransactionType === "redemption") {
                    setRedeemScheme(res?.investmentDetails?.[0])

                }

                if (activeCategory === "New Purchase") {
                    setFolio(res?.investmentDetails?.[0]?.folios?.availableFolios)
                }
                setSchemeLoading(false)

            } catch (error) {
                console.log(error)
                setSchemeLoading(false)
            }
        }

        if (data?.fromSchemeId) fetch()
    }, [data?.fromSchemeId, currentTransactionType])
    return (
        <>
            {["fresh", "additional"].includes(`${currentTransactionType ?? ""}`.toLowerCase()) && (
                <Lumpsum
                    data={data}
                    validation={lumpsumValidation}
                    currentTransactionType={currentTransactionType}
                    folio={folio}
                    schemeLoading={schemeLoading}
                    scheme={lumpsumScheme}
                />
            )}
            {currentTransactionType === 'sip' && (
                <Sip
                    data={data}
                    validation={sipValidation}
                    currentTransactionType={currentTransactionType}
                    folio={folio}
                    schemeLoading={schemeLoading}
                    scheme={sipScheme}

                />
            )}
            {currentTransactionType === 'swp' && (
                <Swp
                    data={data}
                    validation={swpValidation}
                    currentTransactionType={currentTransactionType}
                    scheme={SwpScheme}
                    schemeLoading={schemeLoading}
                    bankDetails={bankDetails}
                />
            )}
            {currentTransactionType === 'stp' && (
                <Stp
                    data={data}
                    validation={stpValidation}
                    currentTransactionType={currentTransactionType}
                    scheme={stpScheme}
                    schemeLoading={schemeLoading}
                    weeklyDaysValidation={weeklyDaysValidation}
                />
            )}
            {currentTransactionType === 'switch' && (
                <Switch
                    data={data}
                    validation={stpValidation}
                    currentTransactionType={currentTransactionType}
                    bankDetails={bankDetails}
                    scheme={switchScheme}
                    schemeLoading={schemeLoading}
                />
            )}
            {currentTransactionType === 'redemption' && (
                <Reedem
                    data={data}
                    validation={stpValidation}
                    scheme={redeemScheme}
                    currentTransactionType={currentTransactionType}
                    bankDetails={bankDetails}
                    schemeLoading={schemeLoading}
                />
            )}
        </>
    )
}

export default Index